export enum NotificationType {
    COMMENT_ON_YOUR_POST = 'COMMENT_ON_YOUR_POST',
    COMMENT_ON_POST_YOU_COMMENTED = 'COMMENT_ON_POST_YOU_COMMENTED',
    COMMENT_ON_POST_YOU_FOLLOW = 'COMMENT_ON_POST_YOU_FOLLOW',
    COMMENT_IN_DOCUMENT_YOU_FOLLOW = 'COMMENT_IN_DOCUMENT_YOU_FOLLOW',
    COMMENT_IN_DOCUMENT_YOU_UPLOADED = 'COMMENT_IN_DOCUMENT_YOU_UPLOADED',
    COMMENT_SELECTED_AS_BEST = 'COMMENT_SELECTED_AS_BEST',
    NEWSLETTER = 'NEWSLETTER',
    JOBS = 'JOBS',
    EXAM_REMINDERS = 'EXAM_REMINDERS',
    JOB_VIBES = 'JOB_VIBES',
}

export enum NotificationChannel {
    PUSH = 'push',
    HEADER = 'header',
    EMAIL = 'email',
}

export interface NotificationSettingResource {
    title?: string;
    type: NotificationType;
    push_available: boolean;
    email_available: boolean;
    header_available: boolean;
    push_enabled?: boolean;
    email_enabled?: boolean;
    header_enabled?: boolean;
}
